export default "__VITE_ASSET__DyIu_HsR__"